import cookiePolicyHtml from '@/content/legal/cookie-policy.html?raw';
import dataProcessingAgreementHtml from '@/content/legal/data-processing-agreement.html?raw';
import foundingCircleAgreementHtml from '@/content/legal/founding-circle-agreement.html?raw';
import platformPrivacyNoticeHtml from '@/content/legal/platform-privacy-notice.html?raw';
import practitionerDeclarationConsentHtml from '@/content/legal/practitioner-declaration-consent.html?raw';
import refundCancellationPolicyHtml from '@/content/legal/refund-cancellation-policy.html?raw';
import saasTermsForNutritionistsHtml from '@/content/legal/saas-terms-for-nutritionists.html?raw';
import websitePrivacyNoticeHtml from '@/content/legal/website-privacy-notice.html?raw';
import websiteTermsOfUseHtml from '@/content/legal/website-terms-of-use.html?raw';

export interface LegalDocument {
  title: string;
  route: string;
  sourceDocument: string;
  documentMeta: string;
  html: string;
}

export const legalDocuments = {
  websiteTerms: {
    title: 'Website Terms of Use',
    route: '/terms',
    sourceDocument: 'Doc 15 Website Terms of Use',
    documentMeta: 'Version 2.1 | Last updated: June 2026',
    html: websiteTermsOfUseHtml,
  },
  platformTerms: {
    title: 'SaaS Terms for Nutritionists',
    route: '/platform-terms',
    sourceDocument: 'Doc 16 SaaS Terms for Nutritionists',
    documentMeta: 'Version 3.4',
    html: saasTermsForNutritionistsHtml,
  },
  foundingCircleAgreement: {
    title: 'Founding Circle Agreement',
    route: '/founding-circle-agreement',
    sourceDocument: 'Founding Circle Agreement',
    documentMeta: 'Version 2.0 | Last updated: June 2026',
    html: foundingCircleAgreementHtml,
  },
  dataProcessingAgreement: {
    title: 'Data Processing Agreement',
    route: '/data-processing-agreement',
    sourceDocument: 'Data Processing Agreement',
    documentMeta: 'Version 1.0',
    html: dataProcessingAgreementHtml,
  },
  practitionerDeclarationConsent: {
    title: 'Practitioner Declaration and Consent',
    route: '/practitioner-declaration-consent',
    sourceDocument: 'Practitioner Declaration and Consent',
    documentMeta: 'Declaration required for practitioner registration',
    html: practitionerDeclarationConsentHtml,
  },
  websitePrivacy: {
    title: 'Privacy Policy',
    route: '/privacy',
    sourceDocument: 'Doc 13 Privacy Policy',
    documentMeta: 'Last updated: June 2026',
    html: websitePrivacyNoticeHtml,
  },
  platformPrivacy: {
    title: 'Platform Privacy Notice',
    route: '/platform-privacy',
    sourceDocument: 'Doc 14 Platform Privacy Notice',
    documentMeta: 'Last updated: June 2026',
    html: platformPrivacyNoticeHtml,
  },
  cookies: {
    title: 'Cookie Policy',
    route: '/cookies',
    sourceDocument: 'Doc 28 Cookie Policy',
    documentMeta: 'Last updated: April 2026',
    html: cookiePolicyHtml,
  },
  refundCancellation: {
    title: 'Refund & Cancellation Policy',
    route: '/refund-cancellation-policy',
    sourceDocument: 'Refund & Cancellation Policy',
    documentMeta: 'CalorieScience Healthtech Pte. Ltd.',
    html: refundCancellationPolicyHtml,
  },
} satisfies Record<string, LegalDocument>;
